import React, { useEffect, useState } from "react";
import { Button, Box, InputLabel } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";

function getUniqueTripTypePreferences(
  preferences = [],
  types = [],
  reportType = "1"
) {
  if (!preferences || !Array.isArray(preferences) || preferences.length === 0) {
    console.warn("No tripType preferences provided");
    return [];
  }
  let tripPreferences = [];
  let tripTypePreferences = [];

  preferences.forEach((preference) => {
    if (!tripPreferences.includes(preference.tripcatg)) {
      tripPreferences.push(preference.tripcatg);
      const tripTypeObj = types.find(
        (type) =>
          type.TRIP_TYPE === parseInt(preference.tripcatg) &&
          type.REPORT_TYPE === parseInt(reportType)
      );
      if (tripTypeObj)
        tripTypePreferences.push({
          tripcatg: String(tripTypeObj.TRIP_TYPE),
          tripcatg_label: tripTypeObj.VALUE,
        });
    }
  });

  return tripTypePreferences;
}

const styles = {
  select: {
    width: window.innerWidth < 750 ? "83%" : "200px",
    marginLeft: window.innerWidth < 750 ? "5px" : "20px",
  },
};

export default function TripType({
  preferences = [],
  currentType,
  types = [],
  handleChange,
  handleTripTypePreferenceChange,
  helpText,
}) {
  const [tripTypePref, setTripTypePref] = useState([]);

  // * Added to remove warning while preferences being loaded.
  useEffect(() => {
    if (preferences.length > 0) {
      const uniqueTripType = getUniqueTripTypePreferences(preferences, types);
      setTripTypePref(uniqueTripType);
    }
  }, [preferences, types]);

  return (
    <Box mt={0} width="100%" align="center" key={"trip_type_box"}>
      <h2 className="sectionTitle center">Trip Type</h2>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        key={"trip_type_container"}
      >
        <Grid item xs={12} md="auto">
          <Box
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
            key={"trip_flex_box"}
          >
            {tripTypePref.map((trip, idx) => (
              <Box m={0.5} key={idx}>
                <Button
                  type="submit"
                  key={"trip_pref_button_" + trip.tripcatg}
                  variant="contained"
                  color="primary"
                  className="form-input"
                  data-new-value={trip.tripcatg}
                  data-field={"trip_type"}
                  size="large"
                  onClick={(e) =>
                    handleTripTypePreferenceChange(e, trip.tripcatg)
                  }
                >
                  {trip.tripcatg_label}
                </Button>
              </Box>
            ))}
          </Box>
        </Grid>

        <Grid item xs={12} md="auto">
          <FormControl variant="standard" sx={styles.select}>
            <InputLabel id="demo-simple-select-helper-label">
              Trip Type
            </InputLabel>
            <Select
              labelId="trip-type-dropdown-label"
              key="trip-type-dropdown-filled"
              data-testid="triptype-select"
              value={currentType}
              onChange={(e) => handleChange(e, e.target.value)}
              name={"trip_type"}
              displayEmpty
            >
              {types.map(function (d, idx) {
                return (
                  <MenuItem key={"tripType_" + idx} value={String(d.KEY)}>
                    {d.VALUE}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <HelpText helpText={getHelpText(helpText, "trip_type")} />
        </Grid>
      </Grid>
    </Box>
  );
}
